import * as actionType from "../constants";
import * as commonData from "../Common";
import { clearAllAttachment } from "./clearAllAttachment";
import { clearFileArray } from "./imageUpload/UploadImage";
import { getBoardHistory } from "./update-single-row";

export const addNoteBoard =
  (inputs, any = null) =>
  async (dispatch) => {
    //dispatch({ type: actionType.NOTE_ADDING });
    const api = commonData.commonData().apiUrl;
    try {
      const resp = await fetch(`${api}note/create`, {
        method: "post",
        body: JSON.stringify(inputs),
      });

      const rdata = await resp.json();
      if (rdata.code === 200) {
        if (any == "status") {
          return rdata;
        }
        const { data } = rdata;
        const listData = {
          app_token: inputs.app_token,
          attribute_set_key: inputs.attribute_set_key,
          customer_tattle_uuid: +inputs.customer_tattle_uuid,
          attribute_set_type: +inputs.attribute_set_type,
        };
        dispatch(getNoteBoard(listData));
        dispatch(
          getBoardHistory({
            ...listData,
            attribute_set_type: +inputs.attribute_set_type,
          })
        );

        dispatch({ type: actionType.NOTE_ADDED });

        setTimeout(() => {
          dispatch(clearAllAttachment());
          if (inputs.get("note_type") === "external") {
            dispatch({ type: actionType.REPLY_TO_CUSTOMER });
          }
          dispatch(clearFileArray());
          dispatch({ type: actionType.POPUP_STOP_DETAILS });
        }, 3000);
        return rdata;
      }
    } catch (error) {
      console.log(error.message);
    }
  };

export const getNoteBoard =
  (inputs, any = null) =>
  async (dispatch) => {
    const api = commonData.commonData().apiUrl;
    try {
      const resp = await fetch(`${api}notes/list`, {
        method: "post",
        body: JSON.stringify(inputs),
      });

      const rdata = await resp.json();
      if (rdata.code === 200) {
        if (any == "status") {
          return rdata;
        }
        dispatch({
          type: actionType.BOARD_NOTE_LIST,
          payload: { notes: rdata.data },
        });
      } else {
        if (any === "status") {
          return;
        }
        dispatch({
          type: actionType.BOARD_NOTE_LIST,
          payload: { notes: [] },
        });
      }
    } catch (error) {
      console.log(error.message);
    }
  };
